// Only allow redirects to pages on this site, never to another address.
export const safeNext = (value: unknown, fallback: string): string => {
    if (typeof value !== 'string') return fallback
    if (!value.startsWith('/') || value.startsWith('//') || value.startsWith('/\\')) return fallback

    return value
}
